const Footer = () => {
  return (
    <footer>
      <div className="wrapper">
        <p>
          {" "}
          <a href="https://junocollege.com/" target="_blank" rel="noreferrer">
            Created at Juno College
          </a>
          &copy;2023
        </p>
      </div>
    </footer>
  );
};

export default Footer;
